import { safeLocalStorageSetJson } from "./storageQuotaRecovery";
import { DB } from "./deviceStorage";

export function readStoredJson(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}

export function readStoredSession() {
  return readStoredJson("fz:session", null);
}

export function writeStoredSession(session) {
  const val = session || null;
  try {
    safeLocalStorageSetJson("fz:session", val);
  } catch (e) {}
  // v2.220.05: manter uma cópia no IndexedDB para recuperar sessão
  // quando o localStorage do WKWebView estiver cheio ou for limpo.
  try {
    DB.set("fz:session", val).catch(() => {});
  } catch (e) {}
}

export function clearStoredSession() {
  try {
    localStorage.removeItem("fz:session");
  } catch (e) {}
  try {
    DB.del("fz:session").catch(() => {});
  } catch (e) {}
}

export function readStoredActiveFarm() {
  return readStoredJson("fz:activeFarm", null);
}

export function writeStoredActiveFarm(farm) {
  const val = farm || null;
  try {
    safeLocalStorageSetJson("fz:activeFarm", val);
  } catch (e) {}
  try {
    DB.set("fz:activeFarm", val).catch(() => {});
  } catch (e) {}
}

export function clearStoredActiveFarm() {
  try {
    localStorage.removeItem("fz:activeFarm");
  } catch (e) {}
  try {
    DB.del("fz:activeFarm").catch(() => {});
  } catch (e) {}
}

export async function restoreSessionFromIdbIfNeeded() {
  try {
    const hasLocalSession = !!localStorage.getItem("fz:session");
    if (hasLocalSession) return { restored: false, reason: "local-session-present" };
    const session = await DB.get("fz:session");
    const activeFarm = await DB.get("fz:activeFarm");
    if (session) {
      safeLocalStorageSetJson("fz:session", session);
    }
    if (activeFarm) {
      safeLocalStorageSetJson("fz:activeFarm", activeFarm);
    }
    return { restored: !!session, session, activeFarm };
  } catch (e) {
    return { restored: false, error: e?.message || "restore-session-idb-failed" };
  }
}

export function clearUpdateDismissalState() {
  try {
    sessionStorage.removeItem("fz:update:dismissed");
    sessionStorage.removeItem("fz:update:postponeUntil");
  } catch (e) {}
}
